import { LoadablePaint } from '@confluence/loadable';

export const SmartCreateSessionLoader = LoadablePaint({
	name: 'SmartCreateSession',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartCreateSession" */ '../src/SmartCreateSession'
			)
		).SmartCreateSession,
});
